exports = module.exports = require("../../node_modules/.pnpm/css-loader@0.28.11/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "table .numerico{min-width:65px;text-align:right}table .size130{min-width:130px}table .total{background:#c1c4c7;border:none}table .var{min-width:85px;text-align:center;background:#c1c4c7;display:inline-block}table .var-negative{color:#fff;background:#cd5c5c}table .var-positive{color:#fff;background:green}table .border-left{border-left:1px solid #dee2e6}.resumo__performance{display:flex;align-items:center;justify-content:space-between}.resumo__performance__value{padding:5px 15px;font-size:18px;font-weight:600;text-align:left;border-radius:10%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/.pnpm/css-loader@0.28.11/node_modules/css-loader?minimize!./node_modules/.pnpm/vue-loader@13.7.3_babel-core@6.26.3_css-loader@0.28.11_vue-template-compiler@2.7.16_webpack@3.12.0/node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-3c33c6fe","scoped":false,"hasInlineConfig":false}!./node_modules/.pnpm/vue-loader@13.7.3_babel-core@6.26.3_css-loader@0.28.11_vue-template-compiler@2.7.16_webpack@3.12.0/node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/consultas/listagem-clientes.vue
// module id = 1342
// module chunks = 0